import {Component, OnInit, signal} from "@angular/core";
import {CommonModule} from "@angular/common";
import {KdWorkplaceComponent} from "../kd-workplace/kd-workplace.component";
import {KdSolutionComponent} from "../kd-solution/kd-solution.component";
import {BootstrapIcon, HeaderService} from "../../../services/header.service";
import {KdWorkplaceSelectionComponent} from "../kd-workplace-selection/kd-workplace-selection.component";
import {KnowledgeBaseService} from "../data-access/knowledge-base.service";
import {UserService} from "src/app/services/user.service";
import {CookieService} from "ngx-cookie-service";
import {Userrole} from "src/app/shared/interfaces/user";
import {SearchFilterBarComponent} from "../../../shared/components/search-filter-bar/search-filter-bar.component";
import {Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {KdSearchResultsComponent} from "../kd-search-results/search-results.component";
import {SearchService} from "../data-access/search.service";
import {Solution} from "../../../shared/interfaces/solution";
import {SolutionService} from "../data-access/solution.service";

@Component({
  selector: "app-kd-dashboard",
  standalone: true,
  imports: [
    CommonModule,
    KdWorkplaceComponent,
    KdSolutionComponent,
    KdWorkplaceSelectionComponent,
    SearchFilterBarComponent,
    KdSearchResultsComponent
  ],
  templateUrl: "./kd-dashboard.component.html",
  styleUrls: ["./kd-dashboard.component.scss"],
})
export class KdDashboardComponent implements OnInit {
  Userrole = Userrole;
  searchParam = signal<string>('');
  userroleFilter = signal<string | null>(null);

  constructor(
    protected knowledgeBaseService: KnowledgeBaseService,
    private searchService: SearchService,
    private apiService: ApiService,
    private userService: UserService,
    private solutionService: SolutionService,
    private cookieService: CookieService,
    private readonly headerService: HeaderService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.knowledgeBaseService.resetState();
    this.knowledgeBaseService.changeActivePage(0);
    this.knowledgeBaseService.resetCurrentLevel();
    this.headerService.setBackgroundColor("#ffffff");
    this.headerService.setHeaderTitle("Wissensdatenbank");
    this.headerService.setHeaderSubTitle("Übersicht");
    this.headerService.setHeaderIcon(BootstrapIcon.knowledgebase);
    this.knowledgeBaseService.activeModule.set("knowledgeBase");

    if (!this.solutionService.isSearchResult()) {
      switch (this.userService.userrole()) {
        case Userrole.Mitarbeiter:
          this.knowledgeBaseService.resetSelectedItems();
          const productionLineWorker = this.cookieService
            .get("productionLine")
            .split("%");
          this.knowledgeBaseService.selectProductionLine(
            productionLineWorker[0],
            true
          );
          this.knowledgeBaseService.updateSelectedItems("productionLine", {
            id: productionLineWorker[0],
            name: productionLineWorker[1],
            type: "productionLine",
          });
          /*const workplace = this.cookieService.get("workplace").split("%");
          this.knowledgeBaseService.selectWorkplace(workplace[0]);
          this.knowledgeBaseService.updateSelectedItems("workplace", {
            id: workplace[0],
            name: workplace[1],
            type: "workplace",
          });
          this.knowledgeBaseService.changeActivePage(1);*/
          this.userroleFilter.set(productionLineWorker[0])
          break;
        case Userrole.Teamleiter:
        case Userrole.Schichtleiter:
          this.knowledgeBaseService.resetSelectedItems();
          const productionLine = this.userService
            .user()
            ?.app_metadata?.["productionLine"].split("%");
          this.knowledgeBaseService.selectProductionLine(productionLine[0], true);
          this.knowledgeBaseService.updateSelectedItems("productionLine", {
            id: productionLine[0],
            name: productionLine[1],
            type: "productionLine",
          });
          this.knowledgeBaseService.changeActivePage(0);
          this.userroleFilter.set(productionLine[0])
          break;
        default:
          this.knowledgeBaseService.resetSelectedItems();
          this.userroleFilter.set(null)
      }
    }
  }

  onValueChange(searchTerm: string) {
    this.searchParam.set(searchTerm)
    console.log(this.searchParam());
  }

  triggerSearch() {
    this.searchService.resetSearchResults()
    console.log('searching with param', this.searchParam())
    if (this.searchParam()) {
      this.searchService.setProductionLineFilter(this.userroleFilter());
      this.searchService.triggerKnowledgeBaseSearch(this.searchParam());
      this.knowledgeBaseService.activePage.set(3)
    }
  }

  back() {
    this.knowledgeBaseService.goBack();
  }
}
